import React from 'react';
import { formatDate } from '../helpers/helpers';

const Footer = (props) => {
    const { item } = props;

    return (
        <div style={{ backgroundColor: 'lightGray', padding: "20px", borderRadius: "6px", justifyContent: 'center', marginBottom: '12px' }}>
            Last updated by <span>{item.modifiedByUser}</span> on <span>{formatDate(item.dateModified)} </span>
            Created on <span>{formatDate(item.dateCreated)}</span> by <span>{item.createdByUser}</span>.
        </div>
    );
};

export default Footer;
